import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { Simulation } from '../Simulation.ts';
import { SimulationApi } from '../../../apis/SimulationApi/SimulationApi.ts';

export function useGetSimulationById(entityId: string) {
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.simulation, entityId],
        queryFn: async () => {
            if (Number(entityId) > 0) {
                const result = await SimulationApi.getSimulationById(entityId);
                console.log(result);
                return new Simulation(result);
            }
        },
        enabled: Number(entityId) > 0,
    });
}
